import { Button, Dialog, DialogActions, Grid, TextField } from "@mui/material";
// import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useWeb3Context } from "../../context/UseWeb3Context";
import { getUser, setOrder } from "../../api/users";
import { useSnackbar } from "notistack";
// import FormikController from "src/formik/FormikController";
import { Formik, Form } from "formik";
import * as Yup from "yup";

const UpdateProfileModal = ({ openModal, closeModal }) => {
  const [error, setError] = useState(false);
  const [values, setValues] = useState({
    fullname: "",
    email: "",
    street: "",
    city: "",
    zip: "",
    state: "",
    country: "",
  });

  const { account } = useWeb3Context();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (account) {
      getUser(account).then((res) => {
        setValues({
          fullname: res?.fullname || "",
          email: res?.email || "",
          street: res?.address?.street || "",
          city: res?.address?.city || "",
          zip: res?.address?.zip || "",
          state: res?.address?.state || "",
          country: res?.address?.country || "",
        });
      });
    }
  }, [account]);

  let userDetails;
  const formSubmitHandler = () => {
    getUser(account).then((res) => {
      userDetails = {
        ...res,
        fullname: values.fullname ? values.fullname : "",
        email: values.email ? values.email : "",
        address: {
          street: values.street ? values.street : "",
          city: values.city ? values.city : "",
          state: values.state ? values.state : "",
          zip: values.zip ? values.zip : "",
          country: values.country ? values.country : "",
        },
      };
      // console.log({ userDetails });
      setOrder(account, userDetails);
      closeModal();
      enqueueSnackbar("Profile Updated...!!!", {
        variant: "success",
        autoHideDuration: 1500,
      });
    });
    // console.log(values);
  };

  const SignupSchema = Yup.object({
    // fullname: Yup.string().required("Required"),
    // email: Yup.string().email("Invalid email").required("Required"),
    // street: Yup.string().required("Required"),
    // city: Yup.string().required("Required"),
    // state: Yup.string().required("Required"),
    // zip: Yup.string().required("Required"),
    // country: Yup.string().required("Required"),
  });

  return (
    <Dialog open={openModal} onClose={closeModal} fullWidth>
      <Grid item xs={12} padding="25px">
        {/* {error && <span>{values.error}</span>} */}
        <Formik
          initialValues={{
            fullname: values.fullname ? values.fullname : "",
            email: values.email ? values.email : "",
            street: values.street ? values.street : "",
            city: values.city ? values.city : "",
            state: values.state ? values.state : "",
            zip: values.zip ? values.zip : "",
            country: values.country ? values.country : "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(e) => {
            formSubmitHandler();
          }}
        >
          {({ errors, touched, isValidating }) => (
            <Form align="center">
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="fullname"
                  name="fullname"
                  label="Full Name"
                  value={values.fullname}
                  onChange={(e) =>
                    setValues({ ...values, fullname: e.target.value })
                  }
                />
                {errors.fullname && touched.fullname ? (
                  <div>{errors.fullname}</div>
                ) : null}
              </Grid>
              <br />
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  type="email"
                  id="email"
                  name="email"
                  label="Email"
                  // defaultValue={values.email}
                  value={values.email}
                  onChange={(e) =>
                    setValues({ ...values, email: e.target.value })
                  }
                />
                {errors.email && touched.email ? (
                  <div>{errors.email}</div>
                ) : null}
              </Grid>
              <br />
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  id="street"
                  name="street"
                  label="Street"
                  value={values.street}
                  onChange={(e) =>
                    setValues({ ...values, street: e.target.value })
                  }
                />
                {errors.street && touched.street ? (
                  <div>{errors.street}</div>
                ) : null}
              </Grid>
              <br />
              <Grid
                container
                spacing={3}
                columns={12}
                display="flex"
                justifyContent="center"
                sx={{ flexDirection: { md: "row", xs: "column" } }}
                align="center"
              >
                <Grid item md={6} xs={12}>
                  <TextField
                    fullWidth
                    required
                    id="city"
                    name="city"
                    label="City"
                    value={values.city}
                    onChange={(e) =>
                      setValues({ ...values, city: e.target.value })
                    }
                  />
                  {errors.city && touched.city ? (
                    <div>{errors.city}</div>
                  ) : null}
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextField
                    required
                    fullWidth
                    id="state"
                    name="state"
                    label="State/Province"
                    value={values.state}
                    onChange={(e) =>
                      setValues({ ...values, state: e.target.value })
                    }
                  />
                  {errors.state && touched.state ? (
                    <div>{errors.state}</div>
                  ) : null}
                </Grid>
              </Grid>
              <br />
              <Grid
                container
                spacing={3}
                columns={12}
                display="flex"
                justifyContent="center"
                sx={{ flexDirection: { md: "row", xs: "column" } }}
                align="center"
              >
                <Grid item md={6} xs={12}>
                  <TextField
                    required
                    fullWidth
                    type="number"
                    id="zip"
                    name="zip"
                    label="Zip"
                    value={values.zip}
                    onChange={(e) =>
                      setValues({ ...values, zip: e.target.value })
                    }
                  />
                  {errors.zip && touched.zip ? <div>{errors.zip}</div> : null}
                </Grid>

                <Grid item md={6} xs={12}>
                  <TextField
                    required
                    fullWidth
                    id="country"
                    name="country"
                    label="Country"
                    value={values.country}
                    onChange={(e) =>
                      setValues({ ...values, country: e.target.value })
                    }
                  />
                  {errors.country && touched.country ? (
                    <div>{errors.country}</div>
                  ) : null}
                </Grid>
              </Grid>
              <DialogActions sx={{ paddingRight: "25px" }}>
                <Button
                  color="primary"
                  type="submit"
                  variant="contained"
                >
                  Save
                </Button>
                <Button variant="outlined" onClick={closeModal}>
                  Cancel
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Grid>
      {/* <DialogActions sx={{ paddingRight: "25px" }}>
        <Button
          color="primary"
          type="submit"
          variant="contained"
          // onClick={formSubmitHandler}
        >
          Save
        </Button>
        <Button variant="outlined" onClick={closeModal}>
          Cancel
        </Button>
      </DialogActions> */}
    </Dialog>
  );
};

export default UpdateProfileModal;
